import { NgModule } from '@angular/core';
import { VideoModalComponent } from './video-modal.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
	declarations: [VideoModalComponent],
	imports: [SharedModule],
	exports: [VideoModalComponent],
})
export class VideoModalModule {}